/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiChannelItem } from '../../asyncapi/models/AaiChannelItem';
import { AaiOperation } from '../../asyncapi/models/AaiOperation';
import { Aai20NodeFactory } from '../../asyncapi/v2/models/Aai20NodeFactory';
import { AbstractCommand } from '../AbstractCommand';
import { JsonCompat } from '../../compat/JsonCompat';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Node } from '../../core/models/Node';

/**
 * A command used to delete all operations from an aai channel.
 * @author c.desc2@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllOperationsCommand_Aai20 extends AbstractCommand {
    static ALL_TYPES : string[]; public static ALL_TYPES_$LI$() : string[] { if(DeleteAllOperationsCommand_Aai20.ALL_TYPES == null) DeleteAllOperationsCommand_Aai20.ALL_TYPES = ["publish", "subscribe"]; return DeleteAllOperationsCommand_Aai20.ALL_TYPES; };

    public _parentPath : NodePath;

    public _oldOperations : Array<any>;

    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>AaiChannelItem) || parent === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldOperations===undefined) this._oldOperations = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldOperations===undefined) this._oldOperations = null;
            (() => {
                this._parentPath = Library.createNodePath(parent);
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldOperations===undefined) this._oldOperations = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldOperations===undefined) this._oldOperations = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllOperationsCommand_Aai20] Executing.");
        this._oldOperations = <any>([]);
        let parentChannel : AaiChannelItem = <AaiChannelItem>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parentChannel)) {
            return;
        }
        for(let index129=0; index129 < DeleteAllOperationsCommand_Aai20.ALL_TYPES_$LI$().length; index129++) {
            let operationType = DeleteAllOperationsCommand_Aai20.ALL_TYPES_$LI$()[index129];
            {
                let oldOp : AaiOperation = <AaiOperation>NodeCompat.getProperty(parentChannel, operationType);
                if(!this.isNullOrUndefined(oldOp)) {
                    let oldOpData : any = JsonCompat.objectNode();
                    JsonCompat.setPropertyString(oldOpData, "_type", operationType);
                    JsonCompat.setProperty(oldOpData, "_operation", Library.writeNode(oldOp));
                    /* add */(this._oldOperations.push(oldOpData)>0);
                    NodeCompat.setProperty(parentChannel, operationType, null);
                }
            }
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllOperationsCommand_Aai20] Reverting.");
        if(this._oldOperations == null || /* size */(<number>this._oldOperations.length) === 0) {
            return;
        }
        let parentChannel : AaiChannelItem = <AaiChannelItem>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parentChannel)) {
            return;
        }
        let nodeFactory : Aai20NodeFactory = new Aai20NodeFactory();
        for(let index130=0; index130 < this._oldOperations.length; index130++) {
            let oldOperationData = this._oldOperations[index130];
            {
                let operationType : string = JsonCompat.getPropertyString(oldOperationData, "_type");
                let operation : AaiOperation = nodeFactory.createOperation(parentChannel, operationType);
                Library.readNode(JsonCompat.getProperty(oldOperationData, "_operation"), operation);
                NodeCompat.setProperty(parentChannel, operationType, operation);
            }
        }
    }
}
DeleteAllOperationsCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllOperationsCommand_Aai20";
DeleteAllOperationsCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





DeleteAllOperationsCommand_Aai20.ALL_TYPES_$LI$();
